module.exports = __webpack_public_path__ + "static/media/OM.44246af9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/OM.svg
// module id = 2234
// module chunks = 7